import router from "../router"
import firebase from 'firebase/app'
import {API_HOST} from "@/helpers/stipe_const";

const CONST = {
    STORE_EXT_URL: 'https://chrome.google.com/webstore/detail/browserlock-kids-mode/bpdfgemboafffcebklpmpgelkjgdpgdl',
};
const connectToExtension = (uid, force = false, cb = () => {}) => {
    console.log('connectToExtension');
    const { Android }  = window;
    try {
        // eslint-disable-next-line no-undef
        if(Android){
            Android.sendJsMsgToWebView(uid);
            localStorage.setItem('isRemote', false);
            cb();
        }
    } catch (error){
        console.log(error);
    }

    if (typeof window !== 'undefined' && !Android) {
        const browser = window.browser || window.chrome;
        if (browser) {
            try {
                browser.runtime.sendMessage(localStorage.getItem('extID'), {uid: uid, force}, () => {
                    if (browser.runtime.lastError) {
                        if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/premium'&& router.currentRoute.path !== '/landing-flow') {
                            router.push('/login')
                        }
                        localStorage.setItem('isRemote', true)
                    } else {
                        localStorage.setItem('isRemote', false)
                        // router.push('/')
                    }
                    cb()
                });
            } catch (e) {
                /**
                 * @if extension with id doesn't exist redirect to login, remove loader
                 */
                console.warn(e)
                localStorage.setItem('isRemote', true);
                if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/premium' && router.currentRoute.path !== '/landing-flow') {
                    router.push('/login');
                }
                cb()
            }
        } else { //firefox
            console.log('firefox');
            if (document.body.classList.contains('ext-installed')) {
                window.addEventListener("message", (event) => {
                    if (event.data && event.data.direction === "from-content-script" && event.data.connectedToExt) {
                        localStorage.setItem('isRemote', false);
                        cb();
                    }
                });
                window.postMessage({
                    direction: 'from-page-script',
                    message: 'connect to extension',
                    uid,
                    force,
                }, '*');
            } else {
                localStorage.setItem('isRemote', true);
                if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/premium') {
                    router.push('/login');
                }
                cb();
            }
        }
    }
}

function getQueryParameterByName(name, url = window.location.href) {
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function reportEvent(eventName, propertyName) {
    const labelData = {};
     const labelDataArr = [];
     if (propertyName) {
         for (const [key, value] of Object.entries(propertyName)) {
             labelData[`${key}`] = `${value}`
         }
     }
     labelDataArr.push(labelData);
     const formData = new FormData()
     formData.append('a', eventName);
     formData.append('l', JSON.stringify(labelDataArr));
     fetch('https://kidsmode.browserlock.net/r/', {
         method: 'POST',
         cache: 'no-cache',
         credentials: 'same-origin',
         body: formData
     });
}

function sendRegistrationEmail(email){
    const options = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({'email': email})
    };
    fetch(`${API_HOST}/api/registration-user`, options).then(data => {
        if (!data.ok) {
            throw Error(data.status);
        }
        return data.json();
    }).catch(e => {
        console.log(e);
    });
}

function getTimeStamp(cb){
    firebase.database().ref( '.info/serverTimeOffset' ).once( 'value', function( snap ) {
        const offset = snap.val();
        // Get server time by milliseconds
        cb( new Date().getTime() + offset );
    });
}

function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}

const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

const getMDY = (timeStamp, daysOffset = 0) => {
    let d = new Date(timeStamp);
    d.setDate(d.getDate() + daysOffset);
    return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`
}

const hitFCMessage = (fcmToken) => {
    const data = {
        "data": {
            "title": "hello",
            "message": "test message"
        },
        "registration_ids": fcmToken,
        "priority": "high"
    };

    fetch('https://fcm.googleapis.com/fcm/send', {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'key=AAAA1gGtnBs:APA91bG-7jA4sQVW5rt5nm40BqxomZBIKSYY_dW5iKW_QLM9vvnqUobbyHpbLi6aMl7N-AHpJkse1B28JQwt6VGMqbUKSTa94hO_AngzljAcuoAvJU3bvuIP0i9P3TsEjLJEZdeuiS6X',
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(data)
    }).then(res => {
        if (!res.ok) {
            throw Error(res.status);
        }
        return res.json();
    }).then(data => {
        console.log(data);
    });
}

export {
    connectToExtension,
    reportEvent,
    getTimeStamp,
    sendRegistrationEmail,
    getQueryParameterByName,
    CONST,
    getMDY,
    getCookie,
    hitFCMessage,
}